// Note that the values must match the names in public/images/logos exactly
const integrationsList = [
  "Aerialytic",
  "Amigo",
  "Aurora",
  "BlueBanyan",
  "Calltools",
  "CallPilot",
  "Copper",
  "Dividend",
  "EnFin",
  "Everbright",
  "Five9",
  "Gamify",
  "Genability",
  "Goodleap",
  "GoogleCalendar",
  "GoogleDrive",
  "GoogleSheets",
  "HighLevel",
  "Hubspot",
  "Insightly",
  "JobNimbus",
  "Jotform",
  "LoanPal",
  "Lumifi",
  "Monday",
  "OneEthos",
  "OpenSolar",
  "PalmettoLightReach",
  "PayKeeper",
  "PipeDrive",
  "Podio",
  "PVWatts",
  "Quickbase",
  "RepCard",
  "SalesForce",
  "SalesRabbit",
  "ScoopSolar",
  "Sendgrid",
  "Smartboard",
  "Smartsheets",
  "Solo",
  "Spinify",
  "Spotio",
  "Sunbase",
  "SungageFinancial",
  "Sunlight",
  "Sunnova",
  "Twilio",
  "Zapier",
  "Zoho",
  "Zoom",
];

export default integrationsList;
